enum VIEW_TYPE {
    ABSOLUTE = 'absolute',
    PERFORMANCE = 'performance'
}
export default VIEW_TYPE;
